import React, { useContext } from "react";
import { db } from "../firebase";

const DatabaseContext = React.createContext();

export function useDatabase() {
  return useContext(DatabaseContext);
}

export function DatabaseProvider({ children }) {
  async function addInvited(uid) {
    const userRef = db.doc(`users/${uid}`);
    let invited = (await userRef.get()).data().invited;
    if (invited <= 10) {
      let invitedFinal = invited + 1;
      let points = (await userRef.get()).data().points + 10;
      await userRef.set(
        {
          invitedFinal,
          points,
        },
        { merge: true }
      );
    }
  }

  async function setReceived(userId, prizeId) {
    let received = true;
    const junctionId = db
      .collection(`purchases`)
      .where("userId", "==", userId)
      .where("prizeId", "==", prizeId)
      .where("received", "==", false)
      .limit(1);
    const junctionRef = db.doc(
      `purchases/${(await junctionId.get()).docs[0].id}`
    );
    await junctionRef.set(
      {
        received,
      },
      { merge: true }
    );
  }

  async function removeReceived(userId, prizeId) {
    let received = false;
    const junctionId = db
      .collection(`purchases`)
      .where("userId", "==", userId)
      .where("prizeId", "==", prizeId)
      .where("received", "==", true)
      .limit(1);
    const junctionRef = db.doc(
      `purchases/${(await junctionId.get()).docs[0].id}`
    );
    await junctionRef.set(
      {
        received,
      },
      { merge: true }
    );
  }

  async function purchasePrize(userId, prizeId) {

    db.doc(`users/${userId}`).get().then((user) => {
      db.doc(`prizes/${prizeId}`).get().then((prize) => {
        if (user.data().points >= prize.data().price) {
          let received = false;
          const junctionRef = db.collection(`purchases`);
          junctionRef.add({
            userId,
            prizeId,
            received,
          }).then(() => {
            let points = user.data().points - prize.data().price;
            db.doc(`users/${userId}`).set({ points }, { merge: true });
          });
          return true;
        } else {
          return false;
        }
      })
    })

  }

  async function cancelPurchase(userId, prizeId) {
    let u = db.collection("users").doc(userId);
    let prize = (await db.collection("prizes").doc(prizeId).get()).data();
    let points = (await u.get()).data().points + prize.price;
    const junctionId = db
      .collection(`purchases`)
      .where("userId", "==", userId)
      .where("prizeId", "==", prizeId)
      .limit(1);
    const junctionRef = db.doc(
      `purchases/${(await junctionId.get()).docs[0].id}`
    );
    await junctionRef.get().then(async (junction) => {
      if (!junction.data().received) {
        await junctionRef.delete();
        await u.set({ points }, { merge: true });
      }
    });
  }

  async function getUserByUid(uid) {
    return (await db.collection("users").doc(uid).get()).data();
  }

  async function accomplishAchievement(userId, achievementId) {
    db.doc(`achievements/${achievementId}`)
      .get()
      .then((achievement) => {
        db.doc(`users/${userId}`)
          .get()
          .then((user) => {
            const points = user.data().points + achievement.data().points;
            db.doc(`users/${userId}`).set({ points }, { merge: true });

            const junctionRef = db.doc(
              `accomplished/${userId}_${achievementId}`
            );
            junctionRef.set({ userId, achievementId });
          });
      });
  }

  async function removeAchievement(userId, achievementId) {
    db.doc(`achievements/${achievementId}`)
        .get()
        .then((achievement) => {
          db.doc(`users/${userId}`)
              .get()
              .then((user) => {
                const points = user.data().points - achievement.data().points;
                db.doc(`users/${userId}`).set({ points }, { merge: true });

                const junctionRef = db.doc(
                    `accomplished/${userId}_${achievementId}`
                );
                junctionRef.delete();
              });
        });
  }

  const value = {
    addInvited,
    purchasePrize,
    cancelPurchase,
    removeReceived,
    setReceived,
    accomplishAchievement,
    removeAchievement,
    getUserByUid,
  };

  return (
    <DatabaseContext.Provider value={value}>
      {children}
    </DatabaseContext.Provider>
  );
}
